import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifSearch from '@ey/motif-react-wrapper/Search';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifInlineMessage from '@ey/motif-react-wrapper/InlineMessage';
import MotifButton from '@ey/motif-react-wrapper/Button';
import styled from 'styled-components';
import Pagination from '../../../Common/Pagination/PaginationMotif';
import {
	currentResource,
	labels,
	pagingOptions,
	engagementsSearchRetainFlag
} from '../../../../util/uiconstants';
import EngagementTable from './EngagementTable';
import env from '../../../../util/env';
import {
	getEngagements,
	resetEngagementData,
	setEngagementSearchParameters
} from '../../../../actions/admin/engagement/engagementActions';
import { getCountries } from '../../../../actions/admin/masterDataActions';
import { getMeCall } from '../../../../actions/admin/mepermissionsactions';
import AccessDeniedMessage from '../../../Common/AccessDeniedMessage/AccessDeniedMessage';
import Loader from '@ey/loader';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';

function EngagementsView() {
	const dispatch = useDispatch();

	const engagementSearchParameters = useSelector(
		(store) => store.engagementSearchParameters
	);
	const engagementData = useSelector((store) => store.engagements);
	const countries = useSelector((store) => store.countries);
	const userPermissions = useSelector((store) => store.userPermissions);

	const [engagementItems, setEngagementItems] = useState([]);
	const [country, setCountry] = useState();
	const [page, setPage] = useState(1);
	const [engagementIdSearch, setEngagementIdSearch] = useState('');
	const [engagementNameSearch, setEngagementNameSearch] = useState('');
	const [clientSearch, setClientSearch] = useState('');
	const [engagementCodeSearch, setEngagementCodeSearch] = useState('');
	const [userSearch, setUserSearch] = useState('');
	const [optionPerPage, setOptionPerPage] = useState(pagingOptions.options[0]);
	const [totalPages, setTotalPages] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [isPageLoading, setIsPageLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);
	const [keyCounter, setKeyCounter] = useState(0);
	const [isMeCallSent, setIsMeCallSent] = useState(false);
	const [isCountryRequired, setIsCountryRequired] = useState(false);
	const [showInvalidEngIdValidationMessage, setShowInvalidEngIdValidationMessage] = useState(false);
	let searchUrl = '';

	useEffect(() => {
		return () => {
			localStorage.setItem(
				engagementsSearchRetainFlag.IsRetainEngagementsSearchResult,
				false
			);
		};
	}, []);

	useEffect(() => {
		var searchRetainView = localStorage.getItem(
			engagementsSearchRetainFlag.IsRetainEngagementsSearchResult
		);
		if (engagementSearchParameters && searchRetainView == 'true') {
			setEngagementIdSearch(engagementSearchParameters?.engagementId);
			setEngagementNameSearch(engagementSearchParameters?.engagementName);
			setClientSearch(engagementSearchParameters?.clientNameCode);
			setEngagementCodeSearch(engagementSearchParameters?.codeOrCodeName);
			setUserSearch(engagementSearchParameters?.userGUIEmailUserId);
			setCountry(engagementSearchParameters?.countryId);
		}
	}, [engagementSearchParameters]);

	useEffect(() => {
		setIsPageLoading(true);
		dispatch(getMeCall())
			.then(() => {
				setIsMeCallSent(true);
				setIsPageLoading(false);
			})
			.catch(() => {
				setIsPageLoading(false);
			})
			.finally(() => {
				setIsPageLoading(false);
			});
	}, []);

	useEffect(() => {
		if (isMeCallSent && isUserEngagementAccess()) {
			if (Object.keys(countries).length === 0) {
				getEngagementCountries();
			}
		}
	}, [isMeCallSent]);

	useEffect(() => {
		var searchRetainView = localStorage.getItem(
			engagementsSearchRetainFlag.IsRetainEngagementsSearchResult
		);
		if (engagementData && searchRetainView == 'true') {
			setEngagementItems(engagementData);
			setTotalPages(engagementData?.totalPageCount);
		}
	}, [engagementData]);

	const getCountriesForDropDown = () => {
		let countryList = [];
		if (Object.keys(countries).length > 0) {
			_.forEach(countries, (item) => {
				if (item) {
					countryList.push({
						value: item.countryId.toString(),
						label: item.countryName
					});
				}
			});
		}
		return countryList;
	};

	const constructSearchUrl = () => {
		if (engagementIdSearch) {
			searchUrl =
				'engagementIdFilter=' + encodeURIComponent(engagementIdSearch);
		}

		if (engagementNameSearch) {
			searchUrl =
				searchUrl + '&engagementNameFilter=' + encodeURIComponent(engagementNameSearch);
		}

		if (clientSearch) {
			searchUrl =
				searchUrl + '&clientFilter=' + encodeURIComponent(clientSearch.replaceAll('"', ''));
		}

		if (engagementCodeSearch) {
			searchUrl =
				searchUrl +
				'&engagementCodeFilter=' +
				encodeURIComponent(engagementCodeSearch.replaceAll('"', ''));
		}

		if (userSearch) {
			searchUrl = searchUrl + '&userFilter=' + encodeURIComponent(userSearch);
		}

		if (country) {
			searchUrl = searchUrl + '&countryIdFilter=' + country;
		}

		return searchUrl;
	};

	const ValidateSearch = () => {
		const searches = [
			engagementNameSearch,
			engagementCodeSearch,
			clientSearch,
			userSearch
		];

		const mandatorySearchFields = [country, engagementIdSearch];

		const isValidSearch = searches.filter((s) => {
			return s?.trim().length > 0;
		});

		const isValidMandatorySearch = mandatorySearchFields.filter((s) => {
			return s?.trim().length > 0;
		});

		if (isValidSearch.length == 0 && isValidMandatorySearch.length == 0) {
			setErrorMessage(true);
			return false;
		}

		if (engagementIdSearch && !Number(engagementIdSearch?.trim())) {
			setShowInvalidEngIdValidationMessage(true);
			return false;
		}

		if (isValidMandatorySearch.length == 0) {
			setIsCountryRequired(true);
			return false;
		}

		return true;
	};

	const saveSearchParameters = (isClearSearch = false) => {
		var searchParameters = {
			engagementId: isClearSearch == true ? '' : engagementIdSearch,
			engagementName: isClearSearch == true ? '' : engagementNameSearch,
			clientNameCode: isClearSearch == true ? '' : clientSearch,
			codeOrCodeName: isClearSearch == true ? '' : engagementCodeSearch,
			userGUIEmailUserId: isClearSearch == true ? '' : userSearch,
			countryId: isClearSearch == true ? '' : country
		};
		dispatch(setEngagementSearchParameters(searchParameters));
	};

	const loadEngagements = (page, optionPerPage) => {
		let validSearch = ValidateSearch();
		if (validSearch) {
			setIsLoading(true);
			setIsCountryRequired(false);
			setShowInvalidEngIdValidationMessage(false);
			setErrorMessage(false);
			constructSearchUrl();
			localStorage.setItem(
				engagementsSearchRetainFlag.IsRetainEngagementsSearchResult,
				true
			);
			saveSearchParameters();

			const reqUrl =
				env.getURL('serviceUrlV2') +
				'admin/Engagements?' +
				searchUrl +
				'&page=' +
				page +
				'&pageSize=' +
				optionPerPage;

			dispatch(getEngagements(reqUrl))
				.then(() => {
					setIsLoading(false);
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	};

	const getEngagementCountries = () => {
		let countriesURL = env.getURL('serviceUrlV2') + 'countries?pageSize=-1';
		dispatch(getCountries(countriesURL)).then(() => { });
	};

	const onEngagementIdSearch = (e) => {
		setErrorMessage(false);
		setIsCountryRequired(false);
		setShowInvalidEngIdValidationMessage(false);
		setEngagementIdSearch(e.target.value);
	}

	const onEngagementNameSearch = (e) => {
		setErrorMessage(false);
		setEngagementNameSearch(e.target.value);
	};
	const onClientSearch = (e) => {
		setErrorMessage(false);
		setClientSearch(e.target.value);
	};
	const onEngagementCodeSearch = (e) => {
		setErrorMessage(false);
		setEngagementCodeSearch(e.target.value);
	};
	const onUserSearch = (e) => {
		setErrorMessage(false);
		setUserSearch(e.target.value);
	};

	const dropDownOnChange = (option) => {
		setErrorMessage(false);
		setIsCountryRequired(false);
		setCountry(option);
	};

	const onSearchButtonClick = () => {
		if (isMeCallSent && isUserEngagementAccess()) {
			loadEngagements(page, optionPerPage);
		}
	};

	const onClear = () => {
		setIsCountryRequired(false);
		setShowInvalidEngIdValidationMessage(false);
		setEngagementItems([]);
		saveSearchParameters(true);
		setCountry();
		setEngagementIdSearch('');
		setEngagementNameSearch('');
		setClientSearch('');
		setEngagementCodeSearch('');
		setUserSearch('');
		dispatch(resetEngagementData());
		setErrorMessage(false);
		setKeyCounter(keyCounter + 1);
		setPage(1);
		localStorage.setItem(
			engagementsSearchRetainFlag.IsRetainEngagementsSearchResult,
			false
		);
	};

	const paginationHandler = (value) => {
		if (page !== value && page > 0) {
			setPage(value);
			loadEngagements(value, optionPerPage);
		}
	};
	const handlerOptionPage = (value) => {
		if (value !== optionPerPage) {
			setOptionPerPage(value);
			setPage(1);
			loadEngagements(1, value);
		}
	};

	const isUserEngagementAccess = () => {
		var permission = userPermissions?.permissions;
		return (
			permission?.canInviteEngagementMember == true ||
			permission?.canReadEngagement == true ||
			permission?.canUpdateEngagement == true ||
			permission?.canUpdateEngagementUser == true ||
			permission?.hasEngagementDefaultRole == true
		);
	};

	return (
		<>
			{isPageLoading ? (
				<Loader />
			) : (
				<Wrapper>
					{!isUserEngagementAccess() ? (
						<AccessDeniedMessage
							permissionMesage={labels.engagementNoPermissionMesage}
						/>
					) : (
						<>
							<section className="desc-wrapper mainResponsiveWrapper motif-body1-default-light">
								{labels.egagementsPageDescription}
							</section>
							{/* <section className="notification mainResponsiveWrapper"> */}
								{errorMessage && (
									<section className="error-section">
											<MotifErrorMessage showIcon>
												{labels.emptySearchFieldError}
											</MotifErrorMessage>
									</section>
								)}
							{/* </section> */}
							<section className="searches-wrapper mainResponsiveWrapper">
								{/* <section className="wrapper"> */}
									<MotifSearch
										maxLength={10}
										value={engagementIdSearch}
										onChange={onEngagementIdSearch}
										placeholder={labels.engagementIdSearchPlaceholder}
										onEnter={onSearchButtonClick}
										onClear={() => setEngagementIdSearch('')}
									></MotifSearch>
									{engagementIdSearch.trim().length != 0 && showInvalidEngIdValidationMessage ? (
										<MotifErrorMessage>
											{labels.adminModuleinvalidEngagementId}
										</MotifErrorMessage>
									) : <></>}
								{/* </section> */}
								<MotifSearch
									maxLength={100}
									value={engagementNameSearch}
									onChange={onEngagementNameSearch}
									placeholder={labels.engagementNameSearchPlaceholder}
									onEnter={onSearchButtonClick}
									onClear={() => setEngagementNameSearch('')}
								></MotifSearch>
								<MotifSearch
									maxLength={100}
									value={clientSearch}
									onChange={onClientSearch}
									placeholder={labels.clientSearchPlaceholder}
									onEnter={onSearchButtonClick}
									onClear={() => setClientSearch('')}
								></MotifSearch>
								<MotifSearch
									maxLength={100}
									value={engagementCodeSearch}
									onChange={onEngagementCodeSearch}
									placeholder={labels.engagementCodeSearchPlaceholder}
									onEnter={onSearchButtonClick}
									onClear={() => setEngagementCodeSearch('')}
								></MotifSearch>
								<MotifSearch
									maxLength={100}
									value={userSearch}
									onChange={onUserSearch}
									placeholder={labels.userSearchPlaceholder}
									onEnter={onSearchButtonClick}
									onClear={() => setUserSearch('')}
								></MotifSearch>
									<MotifFormField className="countrylist">
										<MotifSelect
											id="countries"
											onChange={(e) => dropDownOnChange(e)}
											filter
											arialabelledby="select-label-search"
											key={keyCounter}
											placeholder={labels.countrySearchPlaceholder}
											value={country}
										>
											{getCountriesForDropDown()?.map((item) => (
												<MotifOption
													key={item.value}
													value={item.value}
													label={item.label}
												>
													<EllipsesControl content={item.label} tooltip={item.label} noOfLines={1} />
												</MotifOption>
											))}
										</MotifSelect>
									</MotifFormField>
									{isCountryRequired && (
										<MotifErrorMessage>
											{labels.validationMessage}
										</MotifErrorMessage>
									)}
							</section>
							<section className="searchlink mainResponsiveWrapper">
								<MotifButton
									variant='primary'
									onClick={onSearchButtonClick}
								>
									{currentResource.common.search.buttonTitle}
								</MotifButton>
								<MotifButton
									variant='secondary'
									onClick={onClear}
								>
									{currentResource.common.search.clear}
								</MotifButton>
								<MotifInlineMessage variant='info'>
									{labels.engagementSearchCriteria}
								</MotifInlineMessage>
							</section>
							<EngagementTable data={engagementItems} isLoading={isLoading} />

							{!isLoading && !isPageLoading && <section className="pagerholder">
								<Pagination
									styleName="engagement-paging mainResponsiveWrapper"
									options={pagingOptions.options}
									pageSize={optionPerPage}
									showText={currentResource.common.pagination.show}
									onPageSizeChange={(pageSize) => {
										handlerOptionPage(pageSize);
									}}
									totalPages={totalPages}
									currentPage={page}
									onPageChange={(pageNumber) => {
										paginationHandler(pageNumber);
									}}
								/>
							</section>}
						</>
					)}
				</Wrapper>
			)}
		</>
	);
}

const Wrapper = styled.section`
	overflow: hidden;
	background: var(--neutrals-bg-gradient1);
	padding-top: var(--spacing-xx-large);

	.error-section {
		display: flex;
		align-items: center;
		width: calc(100vw - var(--px-80));
    	margin: 0 auto;
    	max-width: 2048px;
		padding-bottom: var(--spacing-x-large);
	}


	//end of countrylist dropdown

	//pagination

	.pagerholder {
		width: calc(100vw - var(--px-80));
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--spacing-x-large) 0;
	}

	.engagement-paging {
		justify-content: flex-end;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
	}

	.e-icon-wrapper {
		.pageheading {
			display: flex;
			padding-bottom: var(--spacing-large);
			justify-content: space-between;
			svg {
				min-width: var(--px-25) !important;
				min-height: var(--px-25) !important;
				margin-right: var(--px-10);
			}

			h3 {
				margin: 0;
				line-height: var(--px-25);
			}
		}
	}

	.desc-wrapper {
		padding-bottom: var(--spacing-x-large);
	}

	.searchlink{	
		display: flex;
		padding-bottom: var(--spacing-x-large);

		.motif-button {
			margin-right: var(--spacing-large);
		}
		.motif-inline-message {
			align-items: center;
			color: var(--neutrals-900);
			.motif-icon {
				svg path {
					fill: var(--neutrals-900);
				}
			}
		}
	}

	.searches-wrapper {
		display: grid;
		grid-template-columns: auto auto auto auto auto auto;
		grid-gap: 16px;
		padding-bottom: var(--spacing-x-large);
		.wrapper{
			position: relative;
		}

		> * {
			align-self: end;
		}


		.searchlink {
			display: flex;
			padding-bottom: var(--spacing-x-large);
		}
	}
`;

export default EngagementsView;
